import { ButtonV2 } from 'libs/growth-platform-brand-system-v2/src/components/ButtonV2';
import { CardProps } from 'libs/growth-platform-brand-system-v2/src/components/Card';
import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import { createSchema, morphism } from 'morphism';
import React from 'react';
import { schemaImage } from '../components/schemaImage';
import { schemaDatoButton } from '../schemaDatoButton';
import { ImageProps } from 'libs/growth-platform-brand-system-v2/src/components/Image/types';

export const schemaCard = createSchema<CardProps, any>({
  as: 'as',
  title: 'title',
  logo: {
    path: ['logo', 'logoPosition'],
    fn: (propertyValue: any) => {
      const { logo, logoPosition } = propertyValue;
      if (logo?.src) {
        const _logo =
          logoPosition !== 'image'
            ? logo
            : {
                ...logo,
                src: logo?.src,
              };

        const newLogo = {
          ...morphism(schemaImage, {
            ..._logo,
          }),
          sizes: ['120px'],
        } as ImageProps;
        return newLogo;
      }
      return undefined;
    },
  },
  logoPosition: 'logoPosition',
  subtitle: 'subtitle',
  text: 'text',
  name: 'name',
  jobPosition: 'jobPosition',
  companyDescription: 'companyDescription',
  ctaButton: {
    path: ['ctaButton', 'section', 'index', 'locale'],
    fn: ({ ctaButton, section, index, locale }: any) => {
      if (ctaButton?.[0]) {
        const cta = morphism(schemaDatoButton, { ...ctaButton[0], locale });

        return (
          <ButtonTracking
            component={ButtonV2}
            {...cta}
            section={section}
            index={index}
            labelTracking={cta.title}
          />
        );
      }
      return undefined;
    },
  },
  image: {
    path: 'image',
    fn: (propertyValue: any, source: any) => {
      return {
        ...morphism(schemaImage, {
          ...propertyValue,
          altDefault: source?.name,
        }),
        sizes: ['120px'],
      } as ImageProps;
    },
  },
  imagePosition: 'imagePosition',
  capsText: 'capsText',
});
